export default {
    name: "GoPage",
    title: "Go To Page",
    icon: "mdi-page-next-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            route: null,
            page: null,
            parameterName: null
        };
    },
};